export function getDefaultAuthBranding() {
    return {
        appName: process.env.REACT_APP_BRAND_APP_NAME || 'Argyle',
        supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || '',
        supportUrl: process.env.REACT_APP_SUPPORT_URL || '',
        logoUrl: process.env.REACT_APP_BRAND_LOGO_URL || '',
        emailDeliveryHint: process.env.REACT_APP_EMAIL_DELIVERY_HINT || '',
        termsOfServiceUrl:
            process.env.REACT_APP_TERMS_URL ||
            'https://www.argyle.build/terms-of-service',
        privacyPolicyUrl:
            process.env.REACT_APP_PRIVACY_URL ||
            'https://www.argyle.build/privacy-policy',
    }
}

function omitEmpty(overrides) {
    if (!overrides || typeof overrides !== 'object') return {}
    return Object.fromEntries(
        Object.entries(overrides).filter(([, v]) => v != null && v !== '')
    )
}

export function mergeAuthBranding(apiBranding) {
    return { ...getDefaultAuthBranding(), ...omitEmpty(apiBranding) }
}
